/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeedBack } from '../models/FeedBack';
import type { FeedBackCreate } from '../models/FeedBackCreate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeedbackService {
    /**
     * Create Feedback
     * @param requestBody
     * @returns FeedBack Successful Response
     * @throws ApiError
     */
    public static createFeedbackFeedbackPost(
        requestBody: FeedBackCreate,
    ): CancelablePromise<FeedBack> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/feedback/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Feedbacks
     * @param limit
     * @param offset
     * @returns FeedBack Successful Response
     * @throws ApiError
     */
    public static getFeedbacksFeedbackGet(
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<Array<FeedBack>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feedback/',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
